<header class="hdr">
  <a class="brand" routerLink="/companies" aria-label="Vetta home">
    <vt-mark [size]="22" />
    <span class="brand__word">Vetta</span>
  </a>
  <nav class="crumbs mono" aria-label="Breadcrumb">
    @for (c of crumbs(); track $index; let first = $first; let last = $last) {
      @if (!first) {
        <span class="sep" aria-hidden="true">→</span>
      }
      @if (last || !c.link) {
        <span class="current" [attr.aria-current]="last ? 'page' : null">{{ c.label }}</span>
      } @else {
        <a [routerLink]="c.link">{{ c.label }}</a>
      }
    }
  </nav>
  <div class="user">
    <span class="who">
      <span class="mono secondary">{{ auth.user()?.name }}</span>
      <span class="mono muted">{{ auth.user()?.email }}</span>
    </span>
    <button class="avatar" type="button" title="Sign out" (click)="auth.signOut()">
      @if (photo(); as src) {
        <img class="avatar__photo" [src]="src" alt="" (error)="photoFailed.set(true)" />
      } @else {
        {{ initials() }}
      }
    </button>
  </div>
</header>
